import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "calendar.visibility.public": {
        id: 'calendar.visibility.public',
        defaultMessage: 'Public',
    },
    "calendar.visibility.private": {
        id: 'calendar.visibility.private',
        defaultMessage: 'Private',
    }
})

class CalendarVisibilitySelect extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            visibility: this.props.visibility || 'public',
            options: [
                { value: 'public', label: this.props.intl.formatMessage(messages['calendar.visibility.public']) },
                { value: 'private', label: this.props.intl.formatMessage(messages['calendar.visibility.private']) },
            ],
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.visibility !== prevState.visibility) {
            this.setState({
                visibility: this.props.visibility,
            })
        }
    }

    render() {
        return <Select
            name={'calendarVisibility'}
            value={this.state.visibility}
            onChange={selectedOption => {
                this.setState({
                    visibility: selectedOption.value,
                }, () => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.visibility)
                    }
                })
            }}
            options={[
                { value: 'public', label: this.props.intl.formatMessage(messages['calendar.visibility.public']) },
                { value: 'private', label: this.props.intl.formatMessage(messages['calendar.visibility.private']) },
            ]}
            clearable={false}
            searchable={false}
        />
    }
}

export default injectIntl(CalendarVisibilitySelect)


// WEBPACK FOOTER //
// ./src/calendar/calendarvisibilityselect.component.jsx